import { Routes } from '@angular/router'
import { AuthorizedGuard } from '@modules/auth-module/guards/authorized.guard'
import { UnauthorizedGuard } from '@modules/auth-module/guards/unauthorized.guard'
import { SingleTabGuard } from '@shared/guards/single-tab.guard'
import { TechnicalWorksGuard } from '@shared/guards/technical-works.guard'
import { MobileRedirectGuard } from '@shared/guards/mobile-redirect.guard'
import { ProcessedGuard } from '@modules/user-module/guards/processed.guard'
import { NotProcessedGuard } from '@modules/user-module/guards/not-processed.guard'

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'cabinet',
		pathMatch: 'full',
	},
	{
		path: '',
		canActivate: [TechnicalWorksGuard, MobileRedirectGuard],
		canActivateChild: [TechnicalWorksGuard, MobileRedirectGuard],
		children: [
			{
				path: 'auth',
				loadChildren: () => import('./pages/auth/auth.routing').then((m) => m.AuthRouting),
				canActivate: [SingleTabGuard, UnauthorizedGuard],
				canActivateChild: [SingleTabGuard, UnauthorizedGuard, SingleTabGuard],
			},
			{
				path: 'cabinet',
				loadChildren: () => import('./pages/cabinet/cabinet.module').then((m) => m.CabinetModule),
				canActivate: [SingleTabGuard, AuthorizedGuard, ProcessedGuard],
				canActivateChild: [SingleTabGuard, AuthorizedGuard, ProcessedGuard],
			},
			{
				path: 'processing-user',
				loadComponent: () =>
					import('./pages/special/processing-user/processing-user.component').then(
						(m) => m.ProcessingUserComponent,
					),
				canActivate: [SingleTabGuard, NotProcessedGuard],
				canActivateChild: [SingleTabGuard, NotProcessedGuard],
			},
			{
				path: '404',
				loadComponent: () =>
					import('./pages/special/not-found/not-found.component').then((m) => m.NotFoundComponent),
				canActivate: [SingleTabGuard],
				canActivateChild: [SingleTabGuard],
			},
			{
				path: 'technical-works',
				loadComponent: () =>
					import('./pages/special/technical-works/technical-works.component').then(
						(m) => m.TechnicalWorksComponent,
					),
				canActivate: [SingleTabGuard],
				canActivateChild: [SingleTabGuard],
			},
			{
				path: 'single-tab',
				loadComponent: () =>
					import('./pages/special/single-tab/single-tab.component').then((m) => m.SingleTabComponent),
			},
			{
				path: 'mobile-redirect',
				loadComponent: () =>
					import('./pages/special/mobile-redirect/mobile-redirect.component').then(
						(m) => m.MobileRedirectComponent,
					),
			},
			{
				path: 'unavailable-web-terminal',
				loadComponent: () =>
					import('./pages/special/unavailable-web-terminal/unavailable-web-terminal.component').then(
						(m) => m.UnavailableWebTerminalComponent,
					),
				canActivate: [SingleTabGuard, NotProcessedGuard],
				canActivateChild: [SingleTabGuard, NotProcessedGuard],
			},
			{
				path: 'absent-broker-id',
				loadComponent: () =>
					import('./pages/special/absent-broker-id/absent-broker-id.component').then(
						(m) => m.AbsentBrokerIdComponent,
					),
				canActivate: [SingleTabGuard, NotProcessedGuard],
				canActivateChild: [SingleTabGuard, NotProcessedGuard],
			},
			{
				path: 'blocked-user',
				loadComponent: () =>
					import('./pages/special/blocked-user/blocked-user.component').then((m) => m.BlockedUserComponent),
				canActivate: [SingleTabGuard, NotProcessedGuard],
				canActivateChild: [SingleTabGuard, NotProcessedGuard],
			},
			{
				path: '**',
				redirectTo: '404',
			},
		],
	},
]
